<template>
  <b-row>
    <b-col cols="12">
      <div
        v-if="error"
        class="alert alert-dismissible alert-danger"
        role="alert">
        <span v-html="error"></span>
      </div>
      <div
        v-if="deleteError"
        class="alert alert-dismissible alert-danger"
        role="alert">
        <span
          class="fa fa-exclamation-triangle"
          aria-hidden="true"></span> {{ deleteError }}
      </div>
    </b-col>
    <b-col cols="12">
      <router-link :to="{ name: 'ServerList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
    </b-col>
    <b-col cols="12">
      <div class="card">
        <template v-if="isLoading || deleteLoading">
          <Loader></Loader>
        </template>
        <template v-else>
          <div class="card-header">
            <h4 class="card-title">{{$t('views.server.update.title')}}</h4>
          </div>
          <div class="card-body">
            <ServerForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </div>
        </template>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ServerForm from './Form.vue'
import Loader from '../../../Layout/Loader'

export default {
  components: {
    Loader,
    ServerForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'server/update/isLoading',
      error: 'server/update/error',
      deleteError: 'server/del/error',
      deleteLoading: 'server/del/isLoading',
      created: 'server/create/created',
      deleted: 'server/del/deleted',
      retrieved: 'server/update/retrieved',
      updated: 'server/update/updated',
      violations: 'server/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'ServerList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'server/create/reset',
      deleteItem: 'server/del/del',
      delReset: 'server/del/reset',
      retrieve: 'server/update/retrieve',
      updateReset: 'server/update/reset',
      update: 'server/update/update',
      updateRetrieved: 'server/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this server ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.port) {
        this.retrieved.port = parseInt(this.retrieved.port)
      }
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
